/* CasaRosa mobile filter bar — Phase 2 (multi-button)
   Wires every [data-cr-open-filters] / [data-cr-open-sort] button to
   Dawn's existing mobile drawer. Multiple instances now supported
   (sticky bottom bar + inline top button).
*/
(function () {
  function init() {
    var filterBtns = document.querySelectorAll('[data-cr-open-filters]');
    var sortBtns = document.querySelectorAll('[data-cr-open-sort]');

    // Dawn's mobile drawer summary — clicking it toggles the drawer open
    var drawerSummary = document.querySelector('.mobile-facets__wrapper > details > summary');
    if (!drawerSummary) return;

    function openDrawer() {
      drawerSummary.click();
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    sortBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
        // Wait for the drawer's open animation, then scroll the sort section into view
        setTimeout(function () {
          var sortSection = document.querySelector('[id^="Details-Mobile-SortBy-"]');
          if (sortSection) {
            sortSection.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        }, 350);
      });
    });

    // Lock body scroll when drawer is open (some browsers don't do this automatically)
    var drawer = document.querySelector('.mobile-facets__wrapper');
    if (drawer) {
      var details = drawer.querySelector('details');
      if (details) {
        details.addEventListener('toggle', function () {
          if (details.open) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.overflow = '';
          }
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
